/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, toasterrormsg} from '../../../reusable'

const ToursDetailsHeader: React.FC = () => {
  const location = useLocation()
  const toursId = (location.state as any)?.toursId || ''
  const [tourDetails, setTourDetails] = useState([])

  // tours Details api call
  const toursDetailsApiCall = async () => {
    var param: any = {
      toursId: toursId,
    }
    var response: any = await fetchData('vendor/public/toursDetails', param)

    if (response.status == '200') {
      setTourDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    toursDetailsApiCall()
  }, [])

  return (
    <>
      {tourDetails.map((tours: any, index: any) => {
        var imageUrl = ''
        var totalImage = ''
        if (tours['images'].length != 0) {
          imageUrl = tours['images'][0].mediaPath
          totalImage = '+' + (tours['images'].length - 1)
        } else {
          imageUrl = toAbsoluteUrl('/media/avatars/300-1.jpg')
          totalImage = ''
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {totalImage ? (
                      <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 d-flex justify-content-center align-items-center'>
                        {totalImage}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>{tours['en_name']}</div>
                      
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {tours['departureLocation']}
                        </div>
                      </div>
                    </div>

               
                  </div>

                 
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/toursoverview/' && 'active')
                      }
                      to='../toursoverview/'
                      state={{toursId: toursId}}
                    >
                      All Details
                    </Link>
                  </li>
              
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export {ToursDetailsHeader}
